import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFilterOffAg.tsx
const IconFilterOffAg = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "#998e8e",
		d: "M3.6 7.198c0-.53.43-.96.96-.96h14.88a.96.96 0 1 1 0 1.92H4.56a.96.96 0 0 1-.96-.96M7.2 11.998c0-.53.43-.96.96-.96h7.68a.96.96 0 0 1 0 1.92H8.16a.96.96 0 0 1-.96-.96M9.6 16.798c0-.53.43-.96.96-.96h2.88a.96.96 0 0 1 0 1.92h-2.88a.96.96 0 0 1-.96-.96"
	})]
});
var IconFilterOffAg_default = forwardRef(IconFilterOffAg);
//#endregion
export { IconFilterOffAg_default as default };
